var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:{ 'property-modified': _vm.isPropertyModified() }},[_c('span',{staticClass:"capitalize"},[_vm._v(_vm._s(_vm.title))]),(!_vm.hideModified)?_c('span',[_vm._v(" "+_vm._s(_vm.propertyModified()))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e4ba980a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/Property.vue
// module id = null
// module chunks = 